import CardStateLoading from 'app/KinerjaShared/components/CardStateLoading'

import type { FC } from 'react'

type Props = {}

const PageSpinner: FC<Props> = ({}) => {
  return <CardStateLoading />
}

export default PageSpinner
